import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type BannerData } from "@bloomberg/media-ui-nav/dist/types";

const initialState: BannerData = {};

const breakingNewsSlice = createSlice({
    name: "breakingNews",
    initialState,
    reducers: {
        breakingNewsFetched(state, action: PayloadAction<BannerData>) {
            Object.assign(state, action.payload);
        },
    },
});

export const { breakingNewsFetched } = breakingNewsSlice.actions;

export default breakingNewsSlice.reducer;
